import { type ReactElement, useEffect } from 'react';
import { initializeBrandConfig, type BrandConfigOptions } from '@cars4ever/brand-config-core';

import GlobalConfig from '^common/GlobalConfig';
import StoresProvider from '^providers/StoresProvider';
import { BRAND_CONFIG_URL } from '^configs/environments';

import RoutingRules from './RoutingRules';

const App = (): ReactElement => {
  useEffect((): void => {
    const brandConfigOptions: BrandConfigOptions = {
      apiBaseUrl: BRAND_CONFIG_URL,
    };

    void initializeBrandConfig(brandConfigOptions);
  }, []);

  return (
    <GlobalConfig>
      <StoresProvider>
        <RoutingRules />
      </StoresProvider>
    </GlobalConfig>
  );
};

export default App;
